import { PROMOTION_FOR_FREE_PLAN } from '@hooks/useSale'
import { PromotionKey } from '@pages/Checkout/hooks/useGetPromotions'
import { Discount } from '@services/discounts'

import { MonthlyPrice } from '../components/MonthlyPrice'
import { PromotionForFreePlanPrice } from '../components/PromotionForFreePlanPrice'

export const getMonthlyPrice = ({
  finalPrice,
  basicPrice,
  activePromotionKey,
  planPricePerMonthWithoutDiscount,
  discount
}: {
  finalPrice: number
  basicPrice: number
  activePromotionKey: PromotionKey | undefined
  planPricePerMonthWithoutDiscount: number
  discount: Discount | undefined
}) => {
  if (activePromotionKey === PROMOTION_FOR_FREE_PLAN && !discount) {
    return (
      <PromotionForFreePlanPrice
        planPricePerMonth={finalPrice}
        basicPrice={basicPrice}
      />
    )
  }

  return (
    <MonthlyPrice
      planPricePerMonth={finalPrice}
      planPricePerMonthWithoutDiscount={planPricePerMonthWithoutDiscount}
      discount={discount}
    />
  )
}
